import DesktopNav from '@components/_rolex/Page/Header/DesktopNav'
import HeaderContainer from '@components/_rolex/Page/Header/HeaderContainer'
import LogoLink from '@components/_rolex/Page/Header/LogoLink'
import MobileNav from '@components/_rolex/Page/Header/MobileNav'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import React from 'react'

const RCPOHeader: React.FC = () => {
  const router = useRouter()
  const {
    t,
    i18n: { language },
  } = useTranslation('navigation')

  const navItems: { label: string; href: string }[] = [
    {
      label: t('rcpo.index.title'),
      href: `${t('rcpo.index.url')}`,
    },
    {
      label: t('rcpo.selection.title'),
      href: `${t('rcpo.selection.url')}`,
    },
    {
      label: t('rcpo.certification.title'),
      href: `${t('rcpo.certification.url')}`,
    },
    {
      label: t('rcpo.programme.title'),
      href: `${t('rcpo.programme.url')}`,
    },
    {
      label: t('rcpo.contact.title'),
      href: `${t('rcpo.contact.url')}`,
    },
  ]

  return (
    <HeaderContainer variant="rcpo">
      <LogoLink
        href={language === 'nl' ? `${t('rcpo.index.url')}` : `/${language}${t('rcpo.index.url')}`}
        imageSrc="/images/rcpo/rolex-certified-pre-owned-logo.svg"
        alt="RCPO logo"
      />
      <DesktopNav navItems={navItems} language={language} routerPath={router.asPath} />
      <MobileNav
        variant="rcpo"
        navItems={navItems}
        language={language}
        routerPath={router.asPath}
      />
    </HeaderContainer>
  )
}

export default RCPOHeader
